import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { sizeForRatio } from '../../helper/dimension'
import { Color } from '../../style'

const RATIO = {
  width: 178,
  height: 30,
}

interface Props extends SvgProps {}
const Logo = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  const size = sizeForRatio({ width, height }, RATIO)
  return (
    <Svg {...size} viewBox={`0 0 ${RATIO.width} ${RATIO.height}`} {...otherProps}>
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M.664.909v3.564h17.4L-.002 26.701v2.114h23.98v-3.5H6.098l17.88-21.987V.909zM53.337 13.291H73.09c-.484-5.616-4.048-9.544-9.544-9.544-5.858 0-9.6 4.291-10.209 9.544m23.86 3.2l-.242-.12v.12H53.337c.6 5.316 4.411 9.543 10.451 9.543 3.865 0 6.825-1.629 8.094-4.287h4.469c-1.629 4.771-6.523 7.853-12.685 7.853-8.516 0-14.5-6.464-14.5-14.74 0-8.215 5.982-14.678 14.5-14.678 7.973 0 13.531 6.16 13.591 14.558a16.47 16.47 0 01-.06 1.751M156.9 20.178c.846 3.8 3.806 6.1 9.242 6.1 4.531 0 7.611-1.932 7.611-4.952 0-2.477-1.993-3.988-4.833-4.411l-6.342-1.087c-4.65-.725-8.276-2.778-8.276-7.489 0-5.015 4.471-8.276 11.175-8.276 5.678 0 11.6 2.476 12.08 8.878h-3.8c-.544-3.624-3.564-5.556-8.276-5.556-4.409 0-7.127 1.932-7.127 4.651 0 2.114 1.509 3.745 5.5 4.349l5.558.967c4.047.663 8.336 2.416 8.336 7.731 0 5.436-4.892 8.638-11.72 8.638-7.247 0-12.08-3.2-12.985-9.544l3.857.001zM115.828.003c-.217 0-.431-.008-.644 0-.214-.008-.429 0-.646 0-7.007 0-11.9 4.893-11.9 12.746v16.067h4.107V12.93c0-5.766 3.409-9.082 8.437-9.117 5.028.035 8.436 3.351 8.436 9.117v15.887h4.109V12.75c0-7.853-4.893-12.746-11.9-12.746" />
      </G>
    </Svg>
  )
}

export default Logo
